'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import styles from './TravelersHero.module.css';

export default function TravelersHero() {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        <div className={styles.textContainer}>
          <h1 className={styles.mainHeading}>{t('travelersHero.heading')}</h1>
          <p className={styles.description}>{t('travelersHero.description')}</p>
        </div>

        <div className={styles.ctaContainer}>
          <h2 className={styles.ctaHeading}>{t('travelersHero.ctaHeading')}</h2>
          <button className={styles.ctaButton}>{t('travelersHero.ctaButton')}</button>
        </div>
      </div>
    </section>
  );
}
